import Image from 'next/image';
import React from 'react';
import { IOurTechStackProps } from './interface';
import { RichText } from 'prismic-reactjs';
import { IWindowSize, useWindowSize } from '../../../hooks/useWindowSize';
import { imageSerializer } from '../../../utils/imageSerializer';
import {
  DescriptionText,
  Footer,
  FooterTitle,
  FooterValues,
  FooterValuesValue,
  FooterValuesValueImage,
  FooterValuesValueText,
  Icon,
  IconsWrapper,
  Inner,
  Tags,
  Title,
  Wrapper,
} from './ourTechStack.styles';

export const OurTechStack = ({
  title,
  description,
  ourTechStackIcons,
  whatWeCanDoTitle,
  whatWeCanDoValues,
  titleAs,
}: IOurTechStackProps): JSX.Element => {
  const windowSize: IWindowSize = useWindowSize();

  return (
    <Wrapper>
      <Inner>
        <div>
          <Title as={titleAs}>{title}</Title>
          <DescriptionText>{description}</DescriptionText>
          {windowSize.width! <= 1200 && (
            <IconsWrapper>
              {ourTechStackIcons.map(({ icon }, index) => {
                return (
                  <Icon key={index}>
                    <Image {...imageSerializer(icon)} />
                  </Icon>
                );
              })}
            </IconsWrapper>
          )}
          <Tags>
            {ourTechStackIcons.map(
              ({ icon }, index) => icon.alt && `#${icon.alt} `
            )}
          </Tags>
        </div>

        {windowSize.width! > 1200 && (
          <IconsWrapper>
            {ourTechStackIcons.map(({ icon }, index) => {
              return (
                <Icon key={index}>
                  <Image {...imageSerializer(icon)} />
                </Icon>
              );
            })}
          </IconsWrapper>
        )}
      </Inner>
      <Footer>
        <FooterTitle>{whatWeCanDoTitle}</FooterTitle>
        <FooterValues>
          {whatWeCanDoValues.map(({ icon, icon_description }, index) => {
            return (
              <FooterValuesValue key={index}>
                <FooterValuesValueImage>
                  <Image {...imageSerializer(icon)} />
                </FooterValuesValueImage>
                <FooterValuesValueText>
                  {RichText.asText(icon_description)}
                </FooterValuesValueText>
              </FooterValuesValue>
            );
          })}
        </FooterValues>
      </Footer>
    </Wrapper>
  );
};
